























import settings from "@/settings.coffee"
import mutations from "@/gql/mutations.coffee"
import queries from "@/gql/queries.coffee"
import tools from "@/tools.coffee"
import StateComments from "@/components/StateComments.vue"
import EstablishmentReviewContent from '@/components/EstablishmentReviewContent'
import EstablishmentAllMessage from '@/components/EstablishmentAllMessage'

export default {
    "name": "EstablishmentStateAnswerPublished"
    "components": {StateComments, EstablishmentAllMessage, EstablishmentReviewContent}
    "props": {
      "review":{
        "type": Object
      },
    },
    "data": ()->
      return {
          "state": null
      }
    "methods":
        "save_modification": ()->
            if comments?
                @state.data.comments = comments
            serialized = JSON.stringify(@state.data)
            serialized = tools.b64_encode(serialized)
            
            await mutations.run("update_state_data", [@state.uid, serialized])
        "update_data": (comments)->
            
            @state.data.comments = comments
            @save_modification()
    "created": ()->
        self = @
        @state = @review.current_state
        
        if @state.data?
            if typeof @state.data == "string"
                @state.data = JSON.parse(@state.data)

        # for live updates
        self.$djangows['onmodelsignals']({"modelName": "state", "appLabel": "state"}, (event)->
            if event.obj?
                if event.obj.uid == self.state.uid
                    if event.signal_type == "post_save" and event.created == false
                        self.state.data.comments = event.obj.data.comments
        )
}
